export default {
    methods: {
        refresh() {
            window.location.href = '/';
        }
    }
}
